export default "__VITE_ASSET__CPsZsyop__"